import { ExportFormats, ExportPayload } from '@qualio/export-components';
import { PageOrientation, QualioDocument } from '../../../api/model/document';

export const formatVersionLabel = (document: QualioDocument): string => {
  const version = `${document.major_version}.${document.minor_version}`;
  const timestamp =
    document.effective_date ?? document.content_last_modified_at;
  const dateLabel = document.effective_date ? 'Effective' : 'Modified';
  const date = new Date(timestamp * 1000).toISOString().split('T')[0];
  return `${version} (${dateLabel}: ${date})`;
};

export const buildExportPayload = (
  orientation: PageOrientation,
  coverPageEnabled: boolean,
  qualioDocument: QualioDocument,
  compareDocument: QualioDocument,
  html: string,
  generatedBy: string,
  companyName: string,
  includeStrikethrough: boolean,
): ExportPayload => {
  const timestamp = new Date()
    .toISOString()
    .replace(/\.\d{3}Z$/, '')
    .replace('T', '_')
    .replace(/:/g, '-');
  const filename = `${qualioDocument.code}-compare-qualio-document-${timestamp}`;

  const exportHtml = includeStrikethrough
    ? `<div class="accessibility-strikethrough">${html}</div>`
    : html;

  const coverPage = coverPageEnabled
    ? {
        company_name: companyName,
        metadata: [
          {
            name: 'Title',
            metadata_values: [{ value: qualioDocument.title }],
          },
          {
            name: 'Document ID',
            metadata_values: [{ value: qualioDocument.code }],
          },
          {
            name: 'Versions compared',
            metadata_values: [
              { value: formatVersionLabel(qualioDocument) },
              { value: formatVersionLabel(compareDocument) },
            ],
          },
        ],
      }
    : undefined;

  return {
    exports: [
      {
        format: ExportFormats.ckeditor,
        filename,
        html: exportHtml,
        generated_by: generatedBy,
        page_orientation: orientation,
        cover_page: coverPage,
        header: {
          title: qualioDocument.title,
          top_right: companyName,
        },
      },
    ],
    metadata: {
      domain: 'documents',
      resource_name: `${qualioDocument.code} ${qualioDocument.title} compare export`,
    },
  };
};
